<!-- CONFIGURACAO DO CERTIFICADO DIGITAL


            /*
            ATIVACAO DA EXTENSAO DO CHROME PARA USO DO CERTIFICADO A3

            this.filial = this.filialList[index]

            let params = 'uuid=9F2415C5-D99E-4D65-8DDF-9434B0B2DBE5&codnf=847&servico=nfe'

            chrome.runtime.sendMessage('ibohikdagobadchbaemgafbegijoghop', params, function(response) {
            // chrome.runtime.sendMessage('ibohikdagobadchbaemgafbegijoghop', {"text": "teste bbbbb"}, function(response) {
                console.log(response);
            });

            */


 -->

<template>
  <transition name="fade">
    <div class="container" v-if="showForm">
      <!-- EXTENSAO PRECISA SER INSTALADA OU ATUALIZADA -->
      <div v-if="passo === 'extension'" class="default-container">
        <h3 class="cert-title">Atualização necessária do módulo assinador com certificado A3.</h3>
        <alert type="info" title="Aviso"
          text="É necessário efeturar a atualização do módulo assinador para continuar emitindo notas fiscais."></alert>

        <div class="row align-items-center ml-2">
          <span class="numero">1</span>
          <label-title title="Entenda Como Funciona" class=""></label-title>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p class="data-list">Assista no vídeo abaixo o passo a passo para vincular o certificado A3 no Nota Brasil.
            </p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 text-center">
            <iframe src="//www.youtube.com/embed/Ds6DmZ7uzEg" class="ca-u-vertical-offset3" width="560" height="315"
              frameborder="0" allowfullscreen=""></iframe>
          </div>
        </div>
        <div class="row align-items-center ml-2 mt-5">
          <span class="numero">2</span>
          <label-title title="Atualize a Extensão do Chrome" class=""></label-title>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span class="w-100 lbl">Primeiramente certifique-se de que seu certificado A3 esteja conectado (Cartão ou
              Pendrive)</span>
            <span class="w-100 lbl">Em seguida, clique no botão abaixo para ativar a extensão do google chrome para
              utilização do certificado A3 com o Nota Brasil</span>
          </div>
          <div class="col-md-12 mt-2">
            <v-button label="Ativar Extensão no Chrome" :nb-btdef="true" @click="handleAtivarExtensao"></v-button>
          </div>
        </div>
        <div class="row align-items-center ml-2 mt-5">
          <span class="numero">3</span>
          <label-title title="Atualização do Módulo A3" class=""></label-title>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span class="w-100 lbl">Agora efetue o download do módulo de assinatura A3 do Nota Brasil.</span>
            <span class="w-100 lbl"><strong>Após a instalação ser concluída, é necessário reiniciar o seu
                navegador!</strong></span>
          </div>
          <div class="col-md-12 mt-2">
            <v-button label="Download do Nota Brasil A3" :nb-btdef="true" @click="handleDownloadA3"></v-button>
          </div>
        </div>
        <div class="row align-items-center ml-2 mt-5">
          <span class="numero">4</span>
          <label-title title="Retorne para a emissão de notas" class=""></label-title>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span class="w-100 lbl">Agora é só continuar emitindo suas notas.</span>
          </div>
          <div class="col-md-12">
            <v-button label="Retornar Para Lista de Notas" :nb-btdef="true" @click="handleVoltarListaNF"></v-button>
          </div>
        </div>
      </div>

      <div v-if="passo != 'extension'">
        <div class="nb-cert-page-header">
          <div class="nb-cert-title-wrap">
            <h2 class="nb-cert-page-title">Vincular Certificado Digital</h2>
            <div class="nb-cert-filial-meta">
              <strong>{{ filial.nome }}</strong>
              <span v-if="filial.cnpj" class="nb-cert-filial-cnpj">
                <i class="fa fa-id-card-o mr-1" aria-hidden="true"></i>
                CNPJ {{ filial.cnpj | formatCNPJCPF }}
              </span>
            </div>
          </div>
          <div v-if="!disableBtnVoltar" class="nb-cert-back-action">
            <v-button label="Voltar" icon="fa-arrow-left" @click="handleVoltar('closeform')"></v-button>
          </div>
        </div>

        <!-- FILIAL NAO FOI ENCONTRADA -->
        <div v-if="passo === 'empresa'" class="cert-title text-center">
          <h3 class="cert-title">Primeiramente configure os dados da empresa para prosseguir com a vinculação do
            certificado digital.</h3>
          <button type="button" class="cert-button" @click="handleEmpresaRedirect()">Dados da Empresa</button>
        </div>

        <!-- STATUS DO CERTIFICADO -->
        <section class="nb-cert-status mb-4" :class="'nb-cert-status--' + statusCertificado" aria-live="polite">
          <div class="nb-cert-status-summary">
            <div class="nb-cert-status-icon" aria-hidden="true">
              <i class="fa" :class="statusCertificadoIcone"></i>
            </div>
            <div class="nb-cert-status-content">
              <div class="nb-cert-status-heading">
                <h3>{{ statusCertificadoTitulo }}</h3>
                <span class="nb-cert-status-badge">{{ statusCertificadoLabel }}</span>
              </div>
              <p v-if="certificadoVinculado" class="nb-cert-status-detail">
                Certificado {{ tipoCertificado }}
              </p>
              <p v-else class="nb-cert-status-detail">Vincule um certificado para emitir documentos fiscais.</p>
              <div v-if="validadeDisponivel" class="nb-cert-expiry">
                <span>Validade: <strong>{{ filial.certificado[0].dtval | formatData }}</strong></span>
                <span class="nb-cert-expiry-days">{{ validadeCertificadoTexto }}</span>
              </div>
              <div v-if="validadeDisponivel" class="nb-cert-progress" role="progressbar"
                :aria-valuenow="progressoValidade" aria-valuemin="0" aria-valuemax="100"
                :aria-label="'Validade restante: ' + progressoValidade + '%'">
                <div class="nb-cert-progress-bar" :style="{ width: progressoValidade + '%' }"></div>
              </div>
            </div>
          </div>
          <div v-if="certificadoVinculado" class="nb-cert-status-record">
            <app-certificado-form :filial="this.filial" @refresh="handleRefresh"></app-certificado-form>
          </div>
        </section>

        <alert-cert
          v-if="!disableBtnVoltar && (!certificadoVinculado || validadeDisponivel)"
          :certificados="certificadosVenda" />

        <!-- SELECIONA O TIPO DE CERTIFICADO -->

        <div v-if="!certificadoVinculado" id="tipocertificado" class="nb-cert-type-section mb-3">
          <div class="nb-cert-section-heading">
            <h3>Escolha o tipo de certificado</h3>
            <p>Selecione o modelo que sua empresa utiliza para ver as instruções de configuração.</p>
          </div>
          <div class="row">
            <div class="col-md-6 col-12 mb-2 mb-md-0">
              <label class="nb-cert-type-card" :class="{ 'is-selected': tipoCertificado === 'A1' }">
                <input type="radio" name="tipoCertificado" value="A1" v-model="tipoCertificado" class="sr-only">
                <span class="nb-cert-type-icon"><i class="fa fa-file-o" aria-hidden="true"></i></span>
                <span class="nb-cert-type-copy">
                  <strong>Certificado A1</strong>
                  <small>Arquivo digital no formato .pfx</small>
                </span>
                <span class="nb-cert-type-check" aria-hidden="true"><i class="fa fa-check"></i></span>
              </label>
            </div>
            <div class="col-md-6 col-12">
              <label class="nb-cert-type-card" :class="{ 'is-selected': tipoCertificado === 'A3' }">
                <input type="radio" name="tipoCertificado" value="A3" v-model="tipoCertificado" class="sr-only">
                <span class="nb-cert-type-icon"><i class="fa fa-credit-card" aria-hidden="true"></i></span>
                <span class="nb-cert-type-copy">
                  <strong>Certificado A3</strong>
                  <small>Cartão ou token conectado ao computador</small>
                </span>
                <span class="nb-cert-type-check" aria-hidden="true"><i class="fa fa-check"></i></span>
              </label>
            </div>
          </div>
        </div>


        <!-- CONFIGURA NOVO CERTIFICADO A3 -->
        <div v-if="!certificadoVinculado && tipoCertificado == 'A3'" class="nb-cert-setup mt-3">
          <div class="nb-cert-setup-heading">
            <div>
              <h3>Configurar certificado A3</h3>
              <p>Conecte o cartão ou token e siga as etapas abaixo.</p>
            </div>
            <details class="nb-cert-help">
              <summary><i class="fa fa-play-circle mr-1" aria-hidden="true"></i> Assistir tutorial</summary>
              <div class="embed-responsive embed-responsive-16by9 mt-2">
                <iframe src="//www.youtube.com/embed/Ds6DmZ7uzEg" class="embed-responsive-item"
                  title="Tutorial para configurar certificado A3" frameborder="0" allowfullscreen></iframe>
              </div>
            </details>
          </div>

          <div class="nb-cert-steps">
            <article class="nb-cert-step">
              <span class="nb-cert-step-number">1</span>
              <div class="nb-cert-step-copy">
                <h4>Ative a extensão do Chrome</h4>
                <p>Ela permite que o Nota Brasil encontre o certificado conectado.</p>
              </div>
              <div class="nb-cert-step-action">
                <v-button label="Ativar extensão" :nb-btdef="true" @click="handleAtivarExtensao"></v-button>
              </div>
            </article>
            <article class="nb-cert-step">
              <span class="nb-cert-step-number">2</span>
              <div class="nb-cert-step-copy">
                <h4>Instale o módulo A3</h4>
                <p>Depois da instalação, reinicie o navegador.</p>
              </div>
              <div class="nb-cert-step-action">
                <v-button label="Baixar módulo A3" :nb-btdef="true" @click="handleDownloadA3"></v-button>
              </div>
            </article>
            <article class="nb-cert-step">
              <span class="nb-cert-step-number">3</span>
              <div class="nb-cert-step-copy">
                <h4>Vincule o certificado</h4>
                <p>Selecione o certificado disponível no computador.</p>
              </div>
              <div class="nb-cert-step-action">
                <v-button label="Selecionar certificado" :nb-btdef="true"
                  @click="handleCheckExtensionA3"></v-button>
              </div>
            </article>
          </div>
        </div>




        <!-- CONFIGURA NOVO CERTIFICADO A1 -->
        <div v-if="!certificadoVinculado && tipoCertificado == 'A1'" class="nb-cert-a1-layout mt-3">
          <div class="row align-items-start">
            <div class="col-md-7 col-12 order-1 nb-margin-top">
              <div class="nb-cert-a1-form">
                <h3>Importar certificado A1</h3>
                <p>Selecione o arquivo .pfx e informe a senha para vincular o certificado.</p>
                <app-certificado-form :filial="this.filial" @refresh="handleRefresh"></app-certificado-form>
              </div>
            </div>
            <div class="col-md-5 col-12 order-2 mt-3 mt-md-0">
              <div class="nb-cert-a1-help">
                <h4>Precisa de ajuda?</h4>
                <p>Assista ao passo a passo para localizar o arquivo e concluir a importação.</p>
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe src="//www.youtube.com/embed/S6QsrgWAaRM" class="embed-responsive-item"
                    title="Tutorial para importar certificado A1" frameborder="0" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>








        <!-- ATUALIZAÇÃO DA EXTENSAO DO CHROME -->
        <div v-if="passo == 'extension'" class="row card nb-margin-top" style="padding: 15px">
          <div class="row justify-content-md-center">

            <div class="col-md-12 col-12 nb-margin-bottom text-center">
              <h3 class="cert-title">Efetue a instalação da extensão do Google Chrome agora.</h3>
              <p class="data-list">Após a instalação é necessário reiniciar o navegador.</p>
            </div>
            <div class="col-md-6 col-12 nb-margin-top">
              <v-button label="Instalar" :nb-btdef="true" @click="handleAtivarExtensao()"></v-button>
            </div>

          </div>
        </div>

      </div>



      <!-- MODAL PARA CONFIGURACAO DO CERTIFICADO A3 -->
      <div v-if="configurandoA3">
        <div class="nb-modal-mask">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="cert-title" style="margin-bottom: 0">Certificado A3</h3>
              </div>
              <div class="modal-body">
                <div v-if="passo === 'inicio'" class="row col text-center nb-margin-top nb-margin-bottom">
                  <p class="data-list">Primeiramente conecte seu certificado A3 (Cartão ou Pendrive) para iniciar a
                    configuração.</p>
                  <p class="data-list">Em seguida, clique no botão abaixo para ativar a extensão do google chrome para
                    utilização do certificado A3 com o Nota Brasil</p>
                </div>
                <div v-if="passo === 'downloadA3'" class="activation text-center">
                  <p class="data-list">Agora efetue o download do módulo de assinatura A3 do Nota Brasil.</p>
                  <p class="data-list"><strong>Após a instalação ser concluída, é necessário reiniciar o seu
                      navegador!</strong></p>
                </div>
                <div v-if="passo === 'concluido'" class="activation text-center">
                  <p class="data-list"><strong>Após a instalação ser concluída, é necessário reiniciar o seu
                      navegador!</strong></p>
                </div>
              </div>
              <div class="modal-footer">
                <div v-if="passo === 'inicio'">
                  <v-button label="Voltar" @click="configurandoA3 = false"></v-button>
                  <v-button label="Ativar Extensão no Chrome" :nb-btdef="true" @click="handleAtivarExtensao"></v-button>
                </div>
                <div v-if="passo === 'downloadA3'">
                  <v-button label="Voltar" @click="passo = 'inicio'"></v-button>
                  <v-button label="Download do Nota Brasil A3" :nb-btdef="true" @click="handleDownloadA3"></v-button>
                </div>
                <div v-if="passo === 'concluido'">
                  <v-button label="Ok" :nb-btdef="true" @click="handleConcluiA3"></v-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- EFETUA O TESTE NO CERTIFICADO QUANDO A EXTENSAO ESTIVER INSTALADA -->
      <div v-if="testandoA3">
        <div class="nb-modal-mask">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="cert-title" style="margin-bottom: 0">{{ titleValidacaoCertificado }}</h3>
              </div>
              <div class="modal-body">
                <div class="row col text-center nb-margin-top nb-margin-bottom">
                  <p class="data-list">{{ procurandoCertificado }}</p>
                </div>
                <div class="row col text-center nb-margin-top nb-margin-bottom">
                  <p class="data-list">{{ procurandoCertificado2 }}</p>
                </div>
              </div>
              <div class="modal-footer">
                <v-button label="Voltar" @click="testandoA3 = false"></v-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>


import AppCertificadoForm from './app-certificado-form'
import axios from 'axios'
import { urlORDS } from '../shared/api-functions'
import Tourguide from 'tourguidejs';
import { SysVars } from '../main'
import AlertCert from '../components/alert-cert.vue'

export default {
  components: {
    AppCertificadoForm, Tourguide, AlertCert
  },

  props: {
    codfil: [String, Number],
    disableBtnVoltar: [Boolean],
  },

  data() {
    return {
      errmessages: null,
      passo: 'inicio',
      tipoCertificado: '',
      port: null,
      url: urlORDS(this.$store, 'certificado/'),
      configurandoA3: false,
      testandoA3: false,
      filial: null,
      lCodfil: null,
      procurandoCertificado: '',
      procurandoCertificado2: '',
      titleValidacaoCertificado: '',
      guiaConfiguracao: false,


      steps: [
        {
          "selector": "",
          "step": 1,
          "title": `Vamos começar!`,
          "content": "Vamos te guiar passo a passo por todo o processo de Vinculação de Certificado Digital.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#tipocertificado",
          "step": 2,
          "title": `Tipo de Certificado`,
          "content": "Informe o tipo do seu certificado.",
          // "image": "https://somehost.com/image.jpeg"
        },
      ],


    }
  },

  computed: {
    showForm: function () {
      if (this.filial)
        return true
      else
        return false
    },

    diasvalidade: function() {
      if (this.filial && this.filial.certificado && this.filial.certificado.length > 0 && this.filial.certificado[0].dtval)
        return this.$daysBetween(this.$getDate(), this.filial.certificado[0].dtval)
      else
        return 0
    },

    certificadoVinculado() {
      return Boolean(this.filial && Array.isArray(this.filial.certificado) && this.filial.certificado.length > 0)
    },

    validadeDisponivel() {
      return Boolean(this.certificadoVinculado && this.filial.certificado[0].dtval)
    },

    certificadosVenda() {
      if (!this.validadeDisponivel) return []
      const validade = this.diasvalidade === 0 ? 1 : this.diasvalidade
      return [{ validade, dtval: this.filial.certificado[0].dtval }]
    },

    statusCertificado() {
      if (!this.certificadoVinculado) return 'pendente'
      if (!this.validadeDisponivel) return 'indisponivel'
      if (this.diasvalidade < 0) return 'vencido'
      if (this.diasvalidade === 0) return 'vence-hoje'
      if (this.diasvalidade <= 30) return 'proximo'
      return 'valido'
    },

    statusCertificadoTitulo() {
      const titulos = {
        pendente: 'Certificado não configurado',
        valido: 'Certificado válido',
        proximo: 'Certificado próximo do vencimento',
        'vence-hoje': 'Certificado vence hoje',
        vencido: 'Certificado vencido',
        indisponivel: 'Validade não disponível'
      }
      return titulos[this.statusCertificado]
    },

    statusCertificadoLabel() {
      const labels = {
        pendente: 'Pendente',
        valido: 'Ativo',
        proximo: 'Atenção',
        'vence-hoje': 'Vence hoje',
        vencido: 'Vencido',
        indisponivel: 'Verifique os dados'
      }
      return labels[this.statusCertificado]
    },

    statusCertificadoIcone() {
      const icones = {
        pendente: 'fa-exclamation-circle',
        valido: 'fa-check-circle',
        proximo: 'fa-clock-o',
        'vence-hoje': 'fa-exclamation-triangle',
        vencido: 'fa-times-circle',
        indisponivel: 'fa-question-circle'
      }
      return icones[this.statusCertificado]
    },

    validadeCertificadoTexto() {
      if (!this.validadeDisponivel) return ''
      if (this.diasvalidade < 0) {
        const dias = Math.ceil(Math.abs(this.diasvalidade))
        return 'Vencido há ' + dias + (dias === 1 ? ' dia' : ' dias')
      }
      if (this.diasvalidade === 0) return 'Vence hoje'
      return 'Vence em ' + Math.ceil(this.diasvalidade) + ' dias'
    },

    progressoValidade() {
      if (!this.validadeDisponivel || this.diasvalidade <= 0) return 0
      return Math.min(100, Math.max(1, Math.round((this.diasvalidade / 365) * 100)))
    },

    showGuia: function () {
      return SysVars.guia
    }


  },

  watch: {
    codfil: function () {
      // AO SELECIONA A FILIAL
    }
  },

  methods: {
    handleRefresh() {
      this.tipoCertificado = ''
      this.$scrollTo(0)
      this.loadFilial()
    },

    handleEmpresaRedirect() {
      this.$router.push('/filiallist')
    },

    handleAtivarExtensao() {
      window.open('https://chrome.google.com/webstore/detail/nota-brasil-a3/epmndncpbbgiclhagbgoienhimkjhdck', "_blank")
      if (!this.param == 'extension')
        this.passo = 'downloadA3'
    },

    handleDownloadA3() {
      window.open('https://novo.notabrasil.com.br/com.notabrasil.a3.exe', "_blank")
      if (this.passo != 'extension')
        this.passo = 'concluido'
    },

    handleVoltarListaNF() {
      this.$router.go(-1)
    },

    handleConcluiA3() {
      this.loadFilial()
    },

    handleCheckExtensionA3() {
      //CHECA SE A EXTENSAO ESTÁ INSTALADA
      this.$checkExtensaoChromeA3(this.callBackExtensionA3)
    },

    handleTestarA3() {
      //CHECA SE A EXTENSAO ESTÁ INSTALADA
      this.$certificadoTesteA3(this.callBackTesteA3)
    },

    handleVoltar(voltar) {
      if (voltar == 'closeform') {
        this.$emit('closeform')
      }
    },

    callBackExtensionA3(response) {
      console.log('callBackExtensionA3')
      console.log(response)
      //CALLBACK COM RESPOSTA SE A EXTENSAO ESTÁ INSTALADA
      if (response && response.status == 'success') {
        this.titleValidacaoCertificado = 'Validando o Certificado A3...'
        this.procurandoCertificado = 'Tentando localizar um certificado digital neste computador...'
        this.procurandoCertificado2 = 'Caso a tela para seleção do certificados não abra, certifique-se de que o módulo tenha sido corretamente instalado.'
        this.testandoA3 = true
        this.handleTestarA3()
      } else {
        this.configurandoA3 = true
      }
    },

    callBackTesteA3(response) {
      //EFETUA TESTE NO CERTIFICADO A3
      //O TESTE RETORNA response.data COM A DATA DE VALIDADE DO CERTIFICADO
      console.log('callBackExtensionA3')
      console.log(response)

      if (!response) {
        return  //FALTA EXIBIR PAGINA DE ERRO OU TENTAR NOVAMENTE
      }
      if (response.status == 'success') {
        this.titleValidacaoCertificado = 'Configuração Finalizada'
        this.procurandoCertificado2 = ''
        this.apiPostCertificado(response)
      }
      if (response.status == 'error') {
        this.titleValidacaoCertificado = 'Erro...'
        this.procurandoCertificado = response.message
        this.procurandoCertificado2 = 'O certificado não foi configurado.'
      }
    },

    apiPostCertificado(response) {
      //EFETUA O UPLOAD DO CERTIFICADO COMO TIPO A3 APOS TER EFETUADO A VALIDACAO ATRAVÉS DA EXTENSAO

      var self = this
      axios.post(this.url, null,
        {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'filial': this.filial.codfil,
            'tpcertificado': 'A3',
            'data': response.response.validade,  //data de validade
            'nome': response.response.nome  //nome
          }
        }
      ).then(function (data) {
        if (data.items) {
        }
        self.$store.dispatch('loadSessao', self) //ATUALIZA A SESSAO COM O CERTIFICADO INSTALADO
        self.loadFilial()
      })
        .catch(function (data) {
          self.testandoA3 = false
          self.$erpToastError('Erro ao carregar o certificado: ' + data.message)
        })
    },



    async loadFilial() {
      //CARREGA AS INFORMAÇÕES PARA CONFIGURACAO DO CERTIFICADO
      this.testandoA3 = false
      this.configurandoA3 = false
      this.passo = 'inicio'
      await this.$store.dispatch('loadFilial', { id: this.lCodfil })
      if (this.$store.getters.getFilial) {
        this.filial = { ...this.$store.getters.getFilial }
        if (Array.isArray(this.filial.certificado) && this.filial.certificado.length > 0) {
          this.tipoCertificado = this.filial.certificado[0].tipocertificado
          if (this.filial.certificado[0].filename) {
            this.tipoCertificado = 'A1'
          } else {
            this.tipoCertificado = 'A3'
          }
        }


      }

      if (!this.filial) {
        //exibe mensagem para cadastrar uma filial quando nao encontrar a filial
        this.passo = 'empresa'
      }
    },



  },

  async mounted() {

    //CHECA OS PARAMETROS RECEBIDOS DA ROTA
    let param = null
    if (this.codfil)
      param = this.codfil

    if (!param && this.$route.params && this.$route.params.param) {
      param = this.$route.params.param
    }

    if (param == 'extension') { //EXIGE A INSTALACAO OU A ATUALIZACAO DA EXTENSAO
      this.passo = 'extension'
      this.$scrollTo(0)
      return
    } else if (param != null) {
      this.lCodfil = param
    } else {
      this.lCodfil = this.codfil
    }

    //CARREGA A FILIAL PARA CONFIGURACAO DO CERTIFICADO
    await this.loadFilial()
    if (this.filial) {
      this.passo = 'inicio'
      if (this.showGuia && this.steps.length > 0 && !this.certificadoVinculado) {
        var tourguide = new Tourguide({
          steps: this.steps
        });

        tourguide.start();
      }


    } else {
      this.passo = 'empresa'
      return
    }
    this.$scrollTo(0);

  },

  created() {

  }

}

</script>

<style>
.nb-cert-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.nb-cert-title-wrap {
  flex: 1 1 auto;
  min-width: 0;
}

.nb-cert-page-title {
  margin: 0;
  color: #0b1c30;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.nb-cert-filial-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 12px;
  row-gap: 3px;
  margin-top: 4px;
}

.nb-cert-filial-meta > strong {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.nb-cert-filial-cnpj {
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
}

.nb-cert-back-action {
  flex: 0 0 auto;
  white-space: nowrap;
}

.nb-cert-status {
  --cert-status-color: #64748b;
  --cert-status-bg: #f1f5f9;
  --cert-status-border: #cbd5e1;
  display: block;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-left: 4px solid var(--cert-status-color);
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.nb-cert-status-summary {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.nb-cert-status-record {
  margin: 14px 0 0 56px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.nb-cert-status--valido {
  --cert-status-color: #059669;
  --cert-status-bg: #ecfdf5;
  --cert-status-border: #a7f3d0;
}

.nb-cert-status--proximo,
.nb-cert-status--vence-hoje,
.nb-cert-status--pendente {
  --cert-status-color: #d97706;
  --cert-status-bg: #fffbeb;
  --cert-status-border: #fde68a;
}

.nb-cert-status--vencido {
  --cert-status-color: #dc2626;
  --cert-status-bg: #fef2f2;
  --cert-status-border: #fecaca;
}

.nb-cert-status--indisponivel {
  --cert-status-color: #64748b;
  --cert-status-bg: #f1f5f9;
  --cert-status-border: #cbd5e1;
}

.nb-cert-status-icon {
  display: flex;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  color: var(--cert-status-color);
  background: var(--cert-status-bg);
  border-radius: 10px;
  font-size: 19px;
}

.nb-cert-status-content {
  flex: 1;
  min-width: 0;
}

.nb-cert-status-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.nb-cert-status-heading h3 {
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.nb-cert-status-badge {
  padding: 3px 8px;
  color: var(--cert-status-color);
  background: var(--cert-status-bg);
  border: 1px solid var(--cert-status-border);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
}

.nb-cert-status-detail {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
}

.nb-cert-expiry {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px 16px;
  margin-top: 10px;
  color: #475569;
  font-size: 12px;
}

.nb-cert-expiry-days {
  color: var(--cert-status-color);
  font-weight: 700;
}

.nb-cert-progress {
  height: 6px;
  margin-top: 7px;
  overflow: hidden;
  background: #f1f5f9;
  border-radius: 10px;
}

.nb-cert-progress-bar {
  height: 100%;
  background: var(--cert-status-color);
  border-radius: inherit;
  transition: width 0.25s ease;
}

.nb-cert-type-section,
.nb-cert-setup,
.nb-cert-a1-form,
.nb-cert-a1-help {
  padding: 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.nb-cert-section-heading {
  margin-bottom: 14px;
}

.nb-cert-section-heading h3,
.nb-cert-setup-heading h3,
.nb-cert-a1-form h3,
.nb-cert-a1-help h4 {
  margin: 0;
  color: #0b1c30;
  font-size: 16px;
  font-weight: 700;
}

.nb-cert-section-heading p,
.nb-cert-setup-heading p,
.nb-cert-a1-form > p,
.nb-cert-a1-help > p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.nb-cert-type-card {
  display: flex;
  min-height: 82px;
  align-items: center;
  gap: 12px;
  padding: 15px;
  margin: 0;
  color: #0b1c30;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-cert-type-card:hover,
.nb-cert-type-card.is-selected {
  background: #f8fbff;
  border-color: #004e94;
  box-shadow: 0 0 0 2px rgba(0, 78, 148, 0.08);
}

.nb-cert-type-card:focus-within {
  outline: 2px solid #004e94;
  outline-offset: 2px;
}

.nb-cert-type-icon {
  display: flex;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #eff4ff;
  border-radius: 9px;
  font-size: 18px;
}

.nb-cert-type-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 3px;
}

.nb-cert-type-copy strong {
  font-size: 14px;
  font-weight: 700;
}

.nb-cert-type-copy small {
  color: #64748b;
  font-size: 12px;
}

.nb-cert-type-check {
  display: flex;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: transparent;
  border: 1px solid #cbd5e1;
  border-radius: 50%;
  font-size: 11px;
}

.nb-cert-type-card.is-selected .nb-cert-type-check {
  background: #004e94;
  border-color: #004e94;
}

.nb-cert-setup-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.nb-cert-help {
  width: min(100%, 360px);
  color: #004e94;
  font-size: 13px;
}

.nb-cert-help summary {
  cursor: pointer;
  font-weight: 600;
}

.nb-cert-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 14px;
}

.nb-cert-step {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
}

.nb-cert-step-number {
  display: flex;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #eff4ff;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
}

.nb-cert-step-copy {
  flex: 1;
  min-width: 0;
}

.nb-cert-step-copy h4 {
  margin: 0;
  color: #0b1c30;
  font-size: 13px;
  font-weight: 700;
}

.nb-cert-step-copy p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 12px;
}

.nb-cert-step-action {
  flex: 0 0 auto;
}

.nb-cert-a1-help {
  background: #f8fafc;
}

.nb-cert-a1-help .embed-responsive {
  margin-top: 12px;
  border-radius: 8px;
  overflow: hidden;
}

.cert-title {
  margin-bottom: 32px;
  font-size: 30.4px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}

.cert-button {
  border: 2px solid #267da5 !important;
  /* border-radius: 3px!important; */
  border-radius: 0.70rem;
  margin-top: 50px;
  cursor: pointer;
  width: 200px !important;
  height: 45px !important;
  background-color: #267da5 !important;
  color: #fff !important;
  font-size: 15px !important;
}




.numero {
  display: inline-block;
  margin-right: 10px;
  line-height: 28px;
  width: 32px;
  height: 32px;
  text-align: center;
  border: 2px solid #BDBDBD;
  border-radius: 50px;
  color: #3E2F68;
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0px 1px 1px #E0E0E0;
  background-color: #FFF;
}

@media (max-width: 575.98px) {
  .nb-cert-page-header {
    align-items: flex-start;
  }

  .nb-cert-page-title {
    font-size: 19px;
  }

  .nb-cert-status {
    padding: 14px;
  }

  .nb-cert-status-summary {
    gap: 10px;
  }

  .nb-cert-status-icon {
    flex-basis: 36px;
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .nb-cert-status-record {
    margin-left: 46px;
  }

  .nb-cert-type-section,
  .nb-cert-setup,
  .nb-cert-a1-form,
  .nb-cert-a1-help {
    padding: 15px;
  }

  .nb-cert-step {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .nb-cert-step-action {
    margin-left: 44px;
  }

  .nb-cert-status-heading h3 {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/app-certificado.vue